<!-- Route Planner - Two-Row Compact Design -->
<div>
  <!-- Row 1: Start/End stations, Swap, Find Route -->
  <div class="d-flex align-items-center gap-4 mb-4">
    <!-- Start Station -->
    <div class="flex-fill">
      <si-select
        class="form-control"
        hasFilter
        [attr.aria-label]="'MAP_PLANNER.START_STATION' | translate"
        [placeholder]="'MAP_PLANNER.START_PLACEHOLDER' | translate"
        [optionSource]="startStationSource"
        [ngModel]="startStationId()"
        (ngModelChange)="onStartStationChange($event)"
      />
    </div>

    <!-- End Station -->
    <div class="flex-fill">
      <si-select
        class="form-control"
        hasFilter
        [attr.aria-label]="'MAP_PLANNER.END_STATION' | translate"
        [placeholder]="'MAP_PLANNER.END_PLACEHOLDER' | translate"
        [optionSource]="endStationSource"
        [ngModel]="endStationId()"
        (ngModelChange)="onEndStationChange($event)"
      />
    </div>
  </div>

  <!-- Row 2: Waypoints -->
  <div class="d-flex align-items-center flex-wrap gap-2 row-gap-2 mb-3">
    <span class="text-secondary small me-1"> {{ 'MAP_PLANNER.WAYPOINTS' | translate }}: </span>

    <!-- Existing Waypoints with Drag & Drop -->
    <div
      class="d-flex flex-wrap gap-2 align-items-center"
      cdkDropList
      cdkDropListOrientation="horizontal"
      [cdkDropListData]="waypoints()"
      (cdkDropListDropped)="onWaypointDrop($event)"
    >
      @for (waypoint of waypoints(); track waypoint.id) {
        <span
          cdkDrag
          class="border border-secondary rounded-pill d-inline-flex align-items-center gap-1 px-3 py-2 text-secondary waypoint-badge"
          [cdkDragData]="waypoint"
        >
          <si-icon class="icon opacity-75" icon="element-row-move" />
          {{ waypoint.station.stationName }}
          <button
            type="button"
            class="btn-close btn-close-sm ms-1"
            [attr.aria-label]="'MAP_PLANNER.REMOVE_WAYPOINT' | translate"
            (click)="removeWaypoint(waypoint.id); $event.stopPropagation()"
          ></button>
        </span>
      }
    </div>

    <!-- Add Waypoint -->
    @if (isAddingWaypoint() && newWaypointSource) {
      <div class="d-flex align-items-center gap-2 ms-2 waypoint-input-wrapper">
        <si-select
          class="form-control"
          hasFilter
          [attr.aria-label]="'MAP_PLANNER.ADD_WAYPOINT' | translate"
          [placeholder]="'MAP_PLANNER.WAYPOINT_PLACEHOLDER' | translate"
          [optionSource]="newWaypointSource"
          [ngModel]="newWaypointStationId()"
          (ngModelChange)="onWaypointStationChange($event)"
        />
      </div>
    } @else {
      <button type="button" class="btn btn-tertiary btn-sm" (click)="showAddWaypoint()">
        <si-icon class="icon me-1" icon="element-add" />
        {{ 'MAP_PLANNER.ADD' | translate }}
      </button>
    }
  </div>

  <!-- Row 3: Action Buttons -->
  <div class="d-flex align-items-center gap-3 justify-content-end">
    <!-- Clear Button -->
    <button
      type="button"
      class="btn btn-tertiary"
      [disabled]="!startStation() && !endStation() && waypoints().length === 0"
      (click)="clearRoute()"
    >
      {{ 'MAP_PLANNER.CLEAR' | translate }}
    </button>

    <!-- Find Route Button -->
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="!canGenerateRoute()"
      (click)="findRoute()"
    >
      <si-icon class="icon me-2" icon="element-search" />

      {{ 'MAP_PLANNER.FIND_ROUTE' | translate }}
    </button>
  </div>
</div>
